import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CheckboxInput, InputBlock } from 'ecs-react-components/dist/index.es';

import { messages } from './NameRelation.i18n';

class NameRelation extends React.Component {
  render = () => {
    const {
      fields,
      relationships,
      isPrimary,
      onInputChange,
    } = this.props;

    const relationshipOptions = relationships.map((r) => {
      const option = {};
      option.key = r.relationshipId;
      option.value = r.relationshipId;
      option.displayValue = r.relationshipDisplay;
      return option;
    });

    let primaryContactCheckboxAttributes = {};
    if (isPrimary) {
      primaryContactCheckboxAttributes = { tabIndex: 0 };
    }

    const { formatMessage } = this.props.intl;
    return (
      <div className="contact-section">
        <h3 tabIndex="0"><FormattedMessage { ...messages.nameRelation.title } /></h3>
        <div className="spacer tiny"></div>
        <div className="spacer small"></div>
        <div className="row">
          <div className="form-group col-xs-12 col-md-6">
            <InputBlock
              id="contactFirstName"
              labelText={ <FormattedMessage { ...messages.nameRelation.firstName } /> }
              type="text"
              field={ fields.contactFirstName }
              xsSize={12} mdSize={12}
              formGroup={false}
              onChange={onInputChange}
            />
            <InputBlock
              id="contactLastName"
              labelText={ <FormattedMessage { ...messages.nameRelation.lastName } /> }
              type="text"
              field={ fields.contactLastName }
              xsSize={12} mdSize={12}
              formGroup={false}
              onChange={onInputChange}
            />
            <InputBlock
              type="select"
              id="relationshipId"
              labelText={ <FormattedMessage { ...messages.nameRelation.relation } /> }
              field={fields.relationshipId}
              options={relationshipOptions}
              placeHolder={formatMessage(messages.nameRelation.selectOne)}
              qaTag="relationshipSelect"
              xsSize={12} mdSize={12}
              formGroup={false}
            />
          </div>
          <div className="form-group col-xs-12 col-md-6">
            <label htmlFor="otherInformation" tabIndex="0">
              <FormattedMessage { ...messages.nameRelation.otherInformation } />
            </label>
            <div className="checkbox largefont" {...primaryContactCheckboxAttributes}>
              <CheckboxInput
                type="checkbox"
                field={fields.isPrimaryContact}
                qaTag="isPrimaryContact"
                disabled={isPrimary}
                modalConfig={{
                  title: messages.isPrimaryModal.title,
                  message: messages.isPrimaryModal.message,
                  submitBtnText: messages.isPrimaryModal.submitBtnText,
                  hideBtnText: messages.isPrimaryModal.hideBtnText,
                }}
              >
                <FormattedMessage { ...messages.nameRelation.primaryContact } />
              </CheckboxInput>
            </div>
            <div className="checkbox largefont">
              <CheckboxInput
                type="checkbox"
                field={fields.isNextOfKin}
                qaTag="isNextOfKin"
              >
                <FormattedMessage { ...messages.nameRelation.nextOfKin } />
              </CheckboxInput>
            </div>
            <div className="checkbox largefont">
              <CheckboxInput
                type="checkbox"
                field={fields.providesTransport}
                qaTag="isProvidesTransport"
              >
                <FormattedMessage { ...messages.nameRelation.providesTransportation } />
              </CheckboxInput>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NameRelation.propTypes = {
  fields: PropTypes.object,
  relationships: PropTypes.array,
  intl: PropTypes.object,
  isPrimary: PropTypes.bool,
  onInputChange: PropTypes.func,
};

export default (injectIntl(NameRelation));
